import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { TableFilters } from '@frontend/design-system';

type FilterSectionProps = React.ComponentPropsWithoutRef<typeof TableFilters.Section>;

const lineStyle = css`
  margin-top: ${theme.spacing(2)};
  border-top: 1px solid ${theme.colors.neutral20};
`;

export const FilterSection = ({ children, ...props }: FilterSectionProps) => {
  return (
    <TableFilters.Section {...props}>
      {children}
      <div css={lineStyle} />
    </TableFilters.Section>
  );
};
